

<template>
  <VMenu
    offset-y
    open-on-hover
    open-on-click
    close-on-content-click
  >
    <template #activator="{ props }">
      <span v-bind="props"><slot name="text" /></span>
    </template>
    <VCard class="verified-tag-popup">
      <VCardText>
        <slot name="description" />
      </VCardText>
    </VCard>
  </VMenu>
</template>

<style lang="scss" scoped>
.verified-tag-popup{
//background: lightgrey !important;
  max-width: 300px;

}
</style>
